import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import CustomAnalyticsComponent from './custom-analytics.component';

ComponentsFactory.getInstance().define('custom-analytics', CustomAnalyticsComponent);
